import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/hooks/useI18n";
import { AgencyTripRow, TripState } from "@/integrations/supabase/rpc-types";
import type { TranslationKey } from "@/types/i18n.types";

export const TRIP_STATE_LABEL_KEYS: Record<TripState, TranslationKey> = {
  draft: "dashboard.overview.trips.state.draft",
  in_payment: "dashboard.overview.trips.state.in_payment",
  completed: "dashboard.overview.trips.state.completed",
};

const TRIP_STATE_TONES: Record<TripState, string> = {
  draft: "bg-gray-50 text-gray-600 border-gray-200",
  in_payment: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function TripStateBadge({ state }: { state: TripState }) {
  const { t } = useI18n();
  return (
    <Badge variant="outline" className={`whitespace-nowrap ${TRIP_STATE_TONES[state]}`}>
      {t(TRIP_STATE_LABEL_KEYS[state])}
    </Badge>
  );
}

export function tripClientName(row: AgencyTripRow): string {
  return (
    [row.client_first_name, row.client_last_name].filter(Boolean).join(" ").trim() ||
    row.client_email ||
    ""
  );
}

export function tripAdvisorName(row: AgencyTripRow): string | null {
  return [row.advisor_first_name, row.advisor_last_name].filter(Boolean).join(" ").trim() || null;
}

/** Stato grezzo dell'itinerario tradotto; senza traduzione resta il valore del DB. */
export function itineraryStatusLabel(status: string, t: (key: TranslationKey) => string): string {
  const key = `itineraryStatus.${status}`;
  const label = t(key as TranslationKey);
  return label === key ? status : label;
}
